define(['app'], function (app) {
  return app.Marionette.ItemView.extend({
    template: false,

    ui: {
      save_crop: '.js-save-crop',
      cancel_crop: '.js-cancel-crop',
      crop: '.modal-crop__top',
      close_modal: '.mfp-close'
    },

    triggers: {
      'click @ui.save_crop': 'crop:save',
      'click @ui.cancel_crop': 'crop:cancel',
      'click @ui.close_modal': 'crop:cancel'
    },

    components: {
      cropper: function () {
        var self = this
        return {
          name: 'cropper',
          el: '@ui.crop',
          data: {
            width: self.getOption('cropPreviewWidth') ||
              self.getOption('width'),
            height: self.getOption('cropPreviewHeight') ||
              self.getOption('height'),
            margin: self.getOption('margin')
          }
        }
      }
    },

    checkCroppingDimensions: function () {
      var dimensions = this.cropper.getData()
      var width = this.getOption('width')
      var height = this.getOption('height')

      if (width > dimensions.cropW || height > dimensions.cropH) {
        this.ui.save_crop.attr('disabled', 'disabled')
      } else {
        this.ui.save_crop.removeAttr('disabled')
      }
    },

    cropper: false,
    onComponentCropperLoaded: function (instance) {
      this.cropper = instance
      this.listenTo(
        instance,
        'crop:zoom:changed',
        this.checkCroppingDimensions
      )
      this.listenTo(instance, 'crop:change', this.checkCroppingDimensions)
    },

    onModalCroppingSave: function () {
      this.ui.save_crop.addClass('is-loading')
      this.ui.cancel_crop.hide()
    },

    // The ui events
    onCropSave: function () {
      this.cropper.triggerMethod('disable:cropper')
      this.triggerMethod('modal:cropping:save', this.cropper.getData())
    },

    onCropCancel: function () {
      this.triggerMethod('modal:cropping:cancel')
    }
  })
})
